import { devices_config } from '@devices/index';
import { NO_SWITCH_RESET } from 'src/constants';
import { is_GBLE, is_gen_2 } from 'src/helpers/interface_helpers';
import type { Device } from 'src/types/Device';

/**
 * Devices that can expose "Factory reset from input" in the new layout.
 * Matches the old Factory Reset page: Gen1 types not in NO_SWITCH_RESET,
 * or any type with `reset_from_input` in its device config.
 * Bluetooth devices have no input-reset path — hide the row for them.
 */
export function shouldShowFactoryResetFromInputSetting(device: Device | undefined): boolean {
	if (!device?.type || device.shared || is_GBLE(device)) {
		return false;
	}

	const isGen2 = is_gen_2(device);
	const hasResetFromSwitch = !isGen2 && !NO_SWITCH_RESET.includes(device.type);
	const hasResetFromInput = !!devices_config?.[device.type]?.reset_from_input;

	return hasResetFromSwitch || hasResetFromInput;
}
